<p-progressBar class="u-progress-bar" [mode]="mode" [unit]="unit" [showValue]="showValue" [value]="value" [style]="styles"></p-progressBar>
